export default __webpack_public_path__ + "static/media/clap.6ddd10af.png";